// FLAGS: none
// Page shell that sets the document title and forwards a ref.
import { forwardRef } from "react";
import PropTypes from "prop-types";
import PageTitle from "./PageTitle";

const Page = forwardRef(({ children, title = "", ...rest }, ref) => {
  return (
    <div ref={ref} {...rest}>
      <PageTitle title={title} />
      {children}
    </div>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};

export default Page;
